// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "root-3E9aU";
var _4 = "header-1bJtR";
var _5 = "title-1ivTV";
var _6 = "status-1AzaA";
var _7 = "block-BKZGo";
var _8 = "description-34aDG";
var _9 = "footer-2xlAY";
var _a = "code-TnTB1";
var _b = "button-1RzB1";
export { _1 as "__esModule", _2 as "tablet", _3 as "root", _4 as "header", _5 as "title", _6 as "status", _7 as "block", _8 as "description", _9 as "footer", _a as "code", _b as "button" }
export default { "__esModule": _1, "tablet": _2, "root": _3, "header": _4, "title": _5, "status": _6, "block": _7, "description": _8, "footer": _9, "code": _a, "button": _b }
